module.exports = __webpack_public_path__ + "static/media/S1N11-1.30e873f8.svg";